/* eslint-disable no-underscore-dangle */
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpContext } from '@angular/common/http';
import { Store } from '@ngrx/store';
import * as fromApp from '../../app.reducer';
import { Token } from '../../providers/auth/auth.types';
import { RestError } from './rest.types';
import { Observable, Subscription, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root',
})
export class RestService {
	private _token: Token;
	private _tokenSubscription: Subscription;

	constructor(
		private httpClient: HttpClient,
		private store: Store<fromApp.AppState>
	) {
		this._tokenSubscription = this.store.select('auth').subscribe((e: Token) => {
			// console.log('rest service token update');
			// console.log(e);
			if (e && e.access && e.refresh) {
				console.log('set rest service token');
				// console.log(e);
				this._token = e;
			} else {
				if (this._token) {
					console.log('cleared rest.service token');
				}
				this._token = null;
			}
		});
	}

	public get(url: string, context?: HttpContext): Observable<any> {
		// if(this.isNative()){
		//   return this.nativeGet(url);
		// }
		const options = context ? { context } : {};
		return this.httpClient.get(url, options).pipe(catchError((error) => of(new RestError(error, 'Problem making GET.'))));
	}

	public post(url: string, data: any): Observable<any> {
		console.log('post()');
		console.log(url);
		console.log(data);

		// catch native requests in the interceptor after it fails
		return this.httpClient.post(url, data, this.options()).pipe(catchError((error) => of(new RestError(error, 'Problem making POST.'))));

		// if(this.isNative()){
		//   return this.nativeHttp('POST', url, data);
		// }else {
		//   return this.httpClient.post(url, data, this.postOptions())
		// }

		// return from(this.http.post(url, data, {
		//   headers: {
		//       'Content-Type': 'application/json',
		//       'Accept': 'application/json; version='+environment.api_version
		//   }
		// }).catch((err)=>{
		//   console.log('an error with native http');
		//   console.dir(err);
		//   let dataResponse = JSON.parse(err);
		//   console.log('dataResponse');
		//   console.log(dataResponse);
		//
		//   if(err){
		//     for (const key in err) {
		//       console.log(key+':');
		//       console.log(err);
		//     }
		//   }
		//   // alert(err);
		//   return err;
		// }).then((response)=>{
		//   console.log('response status:');
		//   console.log(response.status);
		//   try {
		//     response = JSON.parse(response.data);
		//     // prints test
		//     console.log(response);
		//     console.log(response.message);
		//   } catch(e) {
		//     console.error('JSON parsing error');
		//   }
		// }));
	}

	public patch(url: string, data: any): Observable<any> {
		console.log('patch()');
		console.log(url);
		console.log(data);

		// catch native requests in the interceptor after it fails
		return this.httpClient.patch(url, data, this.options()).pipe(catchError((error) => of(new RestError(error, 'Problem making PATCH.'))));
	}

	public delete(url: string): Observable<any> {
		// DELETE often returns 204 No Content. CapacitorHttp completes the native request but
		// Angular HttpClient can still error while parsing an empty body (Android only).
		return this.httpClient
			.delete(url, {
				headers: this.baseHeaders(),
				responseType: 'text',
			})
			.pipe(
				map((body) => body ?? null),
				catchError((error) => {
					if (this.isSuccessfulEmptyDelete(error)) {
						return of(null);
					}
					return of(new RestError(error, 'Problem making DELETE.'));
				})
			);
	}

	/** CapacitorHttp returns 204 with an empty body; HttpClient may still surface that as a parse error. */
	private isSuccessfulEmptyDelete(error: unknown): boolean {
		if (!error || typeof error !== 'object') {
			return false;
		}

		const err = error as { status?: number; message?: string; name?: string; error?: unknown };
		const status = err.status;

		if (status === 204 || status === 205) {
			return true;
		}

		if (typeof status === 'number' && status >= 200 && status < 300) {
			return true;
		}

		const details = `${err.message ?? ''} ${err.name ?? ''} ${String(err.error ?? '')}`.toLowerCase();
		return details.includes('json') || details.includes('unexpected end');
	}

	private options() {
		return {
			headers: this.baseHeaders(),
			reportProgress: true,
		};
	}

	private baseHeaders() {
		return new HttpHeaders({
			'Content-Type': 'application/json',
			Accept: 'application/json; version=' + environment.api_version,
		});
	}

	// public authHeader() {
	//   return new HttpHeaders({
	//       'Content-Type': 'application/json',
	//       'Accept': 'application/json; version='+environment.api_version,
	//       'Authorization': 'JWT ' + this._stateAccessToken
	//   })
	// }
}
